
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import scrollTab from '@/components/top-tab.vue';
export default {
components: {
scrollTab
},
name: 'lists',
data() {
return {};
},
methods: {

},
watch: {},
computed: {

},
created() {},
mounted() {}
};
